import * as L from 'leaflet'
import "./index.js";
import "./leaflet.mask.js";
import "./blinkmarker.js";
import "./blinkmarker.css";
import china from "./china.json";
import shimian from "./shimian.json";
import yingjing from "./lj.json";
import normal from "./ditu.js";
import legendColor from "./legendColor.json";
// import legendVue from "@/page/legend.vue";
import mapimg from "../assets/map/mapExport.js";
// import { color } from "echarts";
// import { map } from "lodash";
import "./Leaflet.Editable.js";
class MapCreate {
  constructor(map, mapData, mapLegend, mapLegendData) {
    this.map = null;
    // this.mapData = mapData;
    // this.mapLegend = mapLegend;
    // this.mapLegendData = mapLegendData;
  }
  init(type) {

    this.map = L.map(type, {
      center: [ 32.061721,102.990805],  // 初始中心点
      zoom: 10,  // 初始化地图缩放级别
      minZoom: 1, //最小级别
      maxZoom: 18,  //最大缩放级别
      zoomSnap: 0.5, //强制让地图的缩放级别始终为这个值的倍数
      zoomDelta: 0.5, //地图缩放级别改变的值
      doubleClickZoom: false, //双击放大
      // layers: [normal.image], //添加图层
      zoomControl: false, //是否显示缩放控件
      attributionControl: false,  //是否显示右下角的attribution
      wheelPxPerZoomLevel: 300, //较小的值将使滚轮变焦更快 多少滚动像素
      editable: true
    });


    this.map.createPane('labels');
    this.map.getPane('labels').style.zIndex = 500;
    L.tileLayer.chinaProvider('TianDiTu.Satellite.Map'
    ).addTo(this.map);
    var wmsLayer = L.tileLayer.wms(
      'http://120.79.183.250:8081/geoserver/chinamap/wms', {
      layers: "chinamap",
      pane: 'labels'
      // crs: L.CRS.EPSG4326
    }
    );
    //添加图层到地图
    // wmsLayer.addTo(this.map);
    let positronLabels = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion',
      {
        pane: 'labels'
      }
    )
    // positronLabels.setZIndex(999)
    positronLabels.addTo(this.map);
    // const CVA_C = 'http://t1.tianditu.com/cva_c/wmts?layer=cva&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk='
    // const VEC_C = 'http://t1.tianditu.com/vec_c/wmts?layer=vec&style=default&tilematrixset=c&Service=WMTS&Request=GetTile&Version=1.0.0&Format=tiles&TileMatrix={z}&TileCol={x}&TileRow={y}&tk=';
    // let mytestLayer = L.tileLayer(VEC_C + '48dd9495f4ad91f6973ec7c2ffca72c3', {
    //   maxZoom: 20,
    //   tileSize: 256,
    //   zoomOffset: 1,
    // }
    // )
    // mytestLayer.setZIndex(10)
    // mytestLayer.addTo(this.map);
    //地图切换控件 img设置
    // const vector = `<img class='my-layer-img' src='${mapimg.vector}' /> <span class='my-layer-item'>行政图</span>`;
    // const satellitepoi = `<img class='my-layer-img' src='${mapimg.satellitepoi}' /> <span class='my-layer-item'>影像图</span>`;
    // const terrain = `<img class='my-layer-img' src='${mapimg.terrain}' /> <span class='my-layer-item'>地形图</span>`;
    // const vector = `<span class='my-layer-item'>行政图</span>`;
    // const satellitepoi = `<span class='my-layer-item'>影像图</span>`;
    // const terrain = `<span class='my-layer-item'>地形图</span>`;
    // //新建图层控件的数据源-地图
    // const baseLayers = {
    //   [vector]: normal.Gaode,
    //   [satellitepoi]: normal.image,
    //   [terrain]: normal.terrain,
    // };
    // //新建图层控件的数据源-工具
    // // const overlays = {
    // //   地图工具: normal.tool,
    // // };
    // const layerControl = L.control.layers(baseLayers).addTo(this.map);
    // //地图切换控件 img设置
    // layerControl._baseLayersList.style.display = "flex";
    // layerControl._baseLayersList.querySelectorAll("label").forEach((item) => {
    //   item.style.position = "relative";
    //   item.style.marginLeft = "5px";
    //   item.querySelector("input").style.cssText =
    //     "position:absolute;top:0;z-index:1; ";
    // });
    let t = this
    const style = {
      color: "#FCB042", //线颜色
      weight: 5, //线粗细
      opacity: 1, //透明度
      opacity: 1,
      fillColor: "#2F5B00", //区域填充颜色
      fillOpacity: 0, //区域填充颜色的透明
    };
    // L.geoJSON(china.features, { style: style }).addTo(this.map);
    // L.mask(china.features, { fillOpacity: 0.5, fillColor: "#04777A", color: "#04777A", opacity: 0, fitBounds: false, restrictBounds: false }).addTo(this.map);

    //   if (type == "shimian") {
    // L.mask(shimian.features, { fillOpacity: 1, fillColor: "#09132C", fitBounds: false, restrictBounds: false }).addTo(this.map);
    //     const style = {
    //       color: "#f9ca24", //线颜色
    //       weight: 3, //线粗细
    //       opacity: 1, //透明度
    //       fillColor: "#fff", //区域填充颜色
    //       fillOpacity: 0, //区域填充颜色的透明
    //     };
    //     L.geoJSON(shimian.features, {
    //       style: style,
    //       onEachFeature: function (feature, layer) {
    //         // //console.log(feature, layer);

    //         let print = t.getPolygon(feature.geometry.coordinates[0][0])
    //         // //console.log(print);
    //         let myIcon = L.divIcon({
    //           html: `<div class="myareaNameBox" style=" font-size: 12px;  font-weight: 700;
    // color:yellow;-webkit-text-stroke: 0.5px black;
    // ">${feature.properties.name}</div>`,
    //           className: 'my-div-icon',
    //           iconSize: [100, 10]
    //         });
    //         let mymarker = L.marker(print, { zIndexOffset: 1000, icon: myIcon }).addTo(t.map);
    //         // //console.log(mymarker);
    //       }

    //     }).addTo(this.map);
    //     this.map.flyTo([29.21, 102.38], 11)
    //   } else if (type == "yingjing") {
    //     // L.mask(yingjing.features, { fillOpacity: 1, fitBounds: false, restrictBounds: false }).addTo(this.map);
    //     const style = {
    //       color: "#f9ca24", //线颜色
    //       weight: 3, //线粗细
    //       opacity: 1, //透明度
    //       fillColor: "#fff", //区域填充颜色
    //       fillOpacity: 0, //区域填充颜色的透明
    //     };
    //     L.geoJSON(yingjing.features, {
    //       style: style,
    //       onEachFeature: function (feature, layer) {
    //         //console.log(feature, layer);

    //         let print = t.getPolygon(feature.geometry.coordinates[0][0])
    //         //console.log(print);
    //         let myIcon = L.divIcon({
    //           html: `<div class="myareaNameBox" style=" font-size: 12px;
    // color: yellow;-webkit-text-stroke: 2px red;
    // ">${feature.properties.name}</div>`,
    //           className: 'my-div-icon',
    //           iconSize: [100, 10]
    //         });
    //         let mymarker = L.marker(print, { icon: myIcon }).addTo(t.map);
    //         //console.log(mymarker);
    //       }
    //     }).addTo(this.map);
    //     this.map.flyTo([29.79, 102.81], 11)
    //   }


    return this.map
  }
  getPolygon(pList) {
    var area = 0;
    var x = 0;
    var y = 0;
    for (var i = 1; i <= pList.length; i++) {
      var lat = pList[i % pList.length][0];
      var lng = pList[i % pList.length][1];
      var nextLat = pList[i - 1][0];
      var nextLng = pList[i - 1][1];
      var temp = (lat * nextLng - lng * nextLat) / 2;
      area += temp;
      x += (temp * (lat + nextLat)) / 3;
      y += (temp * (lng + nextLng)) / 3;
    }
    x = x / area;
    y = y / area;
    return [y, x];
  }

  mapBorder() {
    //铁路线路
    const Lon = [103.977, 103.4974, 103.0555, 101.963, 100.2901, 97.8408, 95.7676, 94.3636, 91.1377,];
    const Lat = [30.678, 30.1893, 30.0262, 30.0538, 29.9833, 29.6709, 29.859, 29.6421, 29.6526,];
    let data = [];
    Lon.forEach((element, index) => {
      data.push([Lat[index], element]);
    });
    L.polyline(data, {
      color: "black",
      weight: 2,
      className: "dashLines",
    }).addTo(this.map);
    /* 这里分为两个写是因为，层级问题 */
    Lon.forEach((element, index) => {
      L.circleMarker(new L.LatLng(...data[index]), {
        // 创建点 (38, 107)为经纬度
        color: "#0302f1", //线颜色
        weight: 2, //线宽度
        opacity: 1, //透明度
        fillColor: "#0302f1", //填充色
        fillOpacity: 1, //填充透明度
        radius: 5, //半径
      }).addTo(this.map);
    });
    let bounds = [[28, 106], [32, 89],];
    // 创建一个蓝色色的矩形
    L.rectangle(bounds, {
      // color: "#0302f1",
      color: "#0302f1",
      weight: 3,
      fillColor: "#fff",
      fillOpacity: 0,
    }).addTo(this.map);

    // map.fitBounds(bounds);
    //显示文字
    const leftposition = [[28, 89,], [29, 89,], [30, 89,], [31, 89,], [32, 89,], [28, 90], [28, 91], [28, 92], [28, 93], [28, 94], [28, 95], [28, 96], [28, 97], [28, 98], [28, 99], [28, 100], [28, 101], [28, 102], [28, 103], [28, 104], [28, 105], [28, 106]];
    // //console.log(leftposition);
    leftposition.forEach((res, index) => {
      // //console.log(res);
      if (index < 5) {
        const myIcon = L.divIcon({
          className: "NrectangleLatlng",
          html: `<div>${res[0]}°N</div>`,

        });
        L.marker([res[0], res[1] - 0.5], { icon: myIcon }).addTo(this.map);
      } else {
        const myIcon = L.divIcon({
          className: "ErectangleLatlng",
          html: `<span>${res[1]}°E</span>`,
        });
        L.marker(res, { icon: myIcon }).addTo(this.map);
      }


    });
    let t = this
    this.map.on('zoomend', function () {

      // var newzoom = '' + (20*(map.getZoom()+2)) +'px';
      let myIconList = document.querySelectorAll(".ErectangleLatlng")
      // //console.log(myIconList);
      myIconList.forEach((item) => {
        item.style.fontSize = `${t.map.getZoom() * 2}px`
      })

      let myIconList2 = document.querySelectorAll(".NrectangleLatlng")
      // //console.log(myIconList);
      myIconList2.forEach((item) => {
        item.style.fontSize = `${t.map.getZoom() * 2}px`
      })


    });
  }
}
export {
  L,
  legendColor,
  // legendVue,
  // mapimg,
  MapCreate
};
